import { h } from 'preact';
export const LifeBuoy = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("circle", { cx: "12", cy: "12", r: "10" }),
        h("circle", { cx: "12", cy: "12", r: "4" }),
        h("line", { x1: "4.93", y1: "4.93", x2: "9.17", y2: "9.17" }),
        h("line", { x1: "14.83", y1: "14.83", x2: "19.07", y2: "19.07" }),
        h("line", { x1: "14.83", y1: "9.17", x2: "19.07", y2: "4.93" }),
        h("line", { x1: "14.83", y1: "9.17", x2: "18.36", y2: "5.64" }),
        h("line", { x1: "4.93", y1: "19.07", x2: "9.17", y2: "14.83" })));
};
//# sourceMappingURL=life-buoy.js.map